/**
 * BSS B2B Solution integration with Pick Easy app
 * Fix missing:
 * 1. Product note (Line item properties)
 * 2. Order Additional Information (Note attributes / Cart attributes)
 */
(function () {
  window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };
  window.bssB2BHooks.actions = window.bssB2BHooks.actions || {};
  window.bssB2BHooks.filters = window.bssB2BHooks.filters || {};

  let freshCartData = null;

  // 1. ACTION: custom:checkout/delayCheckout
  // Đợi Pick Easy ghi nhận ngày giao hàng vào /cart.js và nạp giỏ hàng mới nhất cho BSS B2B
  window.bssB2BHooks.actions['custom:checkout/delayCheckout'] = async function () {
    try {
      // Đợi ngắn để Pick Easy hoàn tất request Ajax nội bộ
      await new Promise((resolve) => setTimeout(resolve, 400));

      // Fetch cart mới nhất từ Shopify
      const cartRes = await fetch('/cart.js');
      if (cartRes.ok) {
        freshCartData = await cartRes.json();
        
        // Đồng bộ cart mới nhất vào BSS B2B
        if (window.BSS_B2B) {
          if (window.BSS_B2B.shopData) {
            window.BSS_B2B.shopData.cart = freshCartData;
          }
          if (window.BSS_B2B.storage?.cartStorage) {
            freshCartData.items.forEach((item) => {
              const oldItem = window.BSS_B2B.storage.cartStorage.get(item.key);
              if (oldItem) {
                window.BSS_B2B.storage.cartStorage.set(item.key, {
                  ...oldItem,
                  properties: item.properties,
                });
              }
            });
          }
        }
      }
    } catch (e) {
      console.warn('[BSS PickEasy] delayCheckout error:', e);
    }
  };

  // 2. FILTER: custom:data_checkout
  // Đồng bộ Note Attributes và Line Item Properties chuẩn vào Draft Order
  window.bssB2BHooks.filters['custom:data_checkout'] = function (checkoutData) {
    if (!checkoutData) return checkoutData;

    try {
      const cartAttrs = freshCartData?.attributes || checkoutData?.order?.attributes || {};
      const cleanAttrs = { ...cartAttrs };

      // Lọc bỏ dữ liệu rác nội bộ của Pick Easy
      delete cleanAttrs['Slot First Loaded TimeStamp'];

      // 1. Đồng bộ Cart Note Attributes (Order Additional Information)
      checkoutData.order = checkoutData.order || {};
      checkoutData.order.attributes = cleanAttrs;

      // 2. Đồng bộ Line Item Properties (Product Notes của Pick Easy)
      if (freshCartData?.items && Array.isArray(checkoutData.order.items)) {
        checkoutData.order.items.forEach((item) => {
          const freshItem = freshCartData.items.find(
            (fi) => fi.key === item.key || fi.id === item.id || fi.variant_id === item.variant_id
          );
          if (freshItem && freshItem.properties) {
            item.properties = { ...(item.properties || {}), ...freshItem.properties };
          }
        });
      }
    } catch (err) {
      console.warn('[BSS PickEasy] custom:data_checkout error:', err);
    }

    return checkoutData;
  };
})();
